export default __webpack_public_path__ + "static/media/learn.057e4770.svg";